export default __webpack_public_path__ + "static/media/Surprise Gift.be07e25b.png";